import { Sprite } from "../Sprite/Sprite";

export class PickSprite
{
	public spriteCoin:Sprite = null;
	public spriteJp1:Sprite = null;
	public spriteJp2:Sprite = null;
	public spriteJp3:Sprite = null;
	public spriteJp4:Sprite = null;
}